import { useMemo } from 'react';
import { PROJECT_BOLD_TAG } from 'App/featuresFlags';
import { useGetTags } from 'domains/Auth/hooks';

const useIsBoldProject = (): boolean => {
  const tags = useGetTags();
  return useMemo(() => tags.includes(PROJECT_BOLD_TAG), [tags]);
};

export default useIsBoldProject;
